import React from 'react';
import { Header, Footer } from '../../component/index';
import images from '../../images';

const URL = "static/images/partners/";
const PartnerSelect = () => {
    return (
        <div className="form-group">
            <select className="form-control select-partner custom-select">
                <option value="All">All</option>
                { images.map((each, index) => { return <option key={index} value={each.region}>{each.region}</option> })}
            </select>
        </div>
    )
}
const PartnerCard = () => {
    return (
        images.map( (each, index) => {
            return (
                <div key={index} className="col-11 text-center m-t-15 m-b-30">
                    <div className="card-box p-0">
                        <div key={index} className="card-header partner-header bg-info text-white font-24">{each.region}</div>
                        <div className="card-body partner-body">
                            <div className="row">
                                {each.brands.map((brand, idx) => { return <div key={idx} className="col-md-3 col-sm-4 m-b-25"><img key={idx} src={URL+brand} alt={brand}/></div> }) }
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    )
}
const Partner = () => {
    return (
        <>
        <Header homepage={false}/>
        <div className="wrapper">
            <div className="container-w-lg">
                <div className="row">
                    <img src="static/images/img_banner_partner.png" alt="features" width="100%"/>
                </div>
            </div>
            <div className="container-fluid m-b-50">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="page-title-box p-0 m-t-50">
                            <h4 className="page-title mb-10">Partner</h4>
                        </div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="row">
                        <div className="title_underline"></div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-4 m-t-50">
                        <PartnerSelect/>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <PartnerCard/>
                </div>
            </div>
            <div className="above-footer"></div>
        </div>
        <Footer/>
        </>
    )
}

export default Partner;